<template>
<!-- 
    * Copyright: T-Systems México S.A. de C.V.
    * Descripción: Vista mapas, permite consultar, crear, editar y cambiar el estado de un mapa
    * Autor: 
    * F.Creación: 
  -->
  <layout :title="$t('moduleTitle')">
    <!-- Contenido -->
    <template v-slot:content>
      <v-dialog persistent v-model="viewMapDialogFlag" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgMapTitle")}}</v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <p class="mt-5" v-html="currentMap.name"></p>
                </v-col>
                <v-col cols="12" center>
                  <v-progress-linear
                    v-if="pdfProgress > 0 && pdfProgress < 100"
                    v-model="progress"
                    height="25"
                    reactive
                  >
                    <strong>{{ pdfProgress }}%</strong>
                  </v-progress-linear>
                </v-col>
                <v-col cols="12">
                  <pdf
                    v-show="pdfProgress === 100"
                    :src="mapURL"
                    @progress="setPdfProgress($event)"
                  ></pdf>
                </v-col>
                <v-col cols="12">
                  <p class="primary--text" v-html="currentMap.resource.content"></p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click.stop="closeShowMapDialog();">{{$t("btnOk")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="uploadMapDialogFlag" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgNewMapTitle")}}</v-card-title>

          <v-card-text>
            <v-container>
              <v-form ref="updateMapForm" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-file-input
                      show-size
                      accept=".pdf"
                      :hint="$t('lblFileName')"
                      persistent-hint
                      prepend-icon
                      v-model="files"
                      append-icon="mdi-folder-search"
                      v-on:change="handleFileUpload"
                    />
                  </v-col>
                  <v-col cols="12" center>
                    <v-progress-linear v-if="progress > 0" v-model="progress" height="25" reactive>
                      <strong>{{ progress }}%</strong>
                    </v-progress-linear>
                  </v-col>
                  <v-col cols="12">
                    <p class="caption error--text" v-html="errorMessage"></p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeUploadMapDialog()">{{$t("btnCancel")}}</v-btn>
            <v-btn text @click.stop="doUploadMapDialog()" color="primary">{{$t("btnUpdateMap")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="deleteMapDialogFlag" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgDeleteMapTitle")}}</v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <p class="mt-10" v-html="$t('dlgDeleteText', { mapName: currentMap.name })"></p>
                </v-col>
                <v-col cols="12">
                  <p class="caption error--text" v-html="errorMessage"></p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeDeleteMapDialog()">{{$t("btnCancel")}}</v-btn>
            <v-btn text @click.stop="doDeleteMapDialog()" color="primary">{{$t("btnDeleteMap")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="newMapDialogFlag" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgNewMapTitle")}}</v-card-title>

          <v-card-text>
            <v-container>
              <v-form ref="newMapForm" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="currentMap.name" :label="$t('lblMapName')"></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field v-model="currentMap.comments" :label="$t('lblMapDescription')"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="currentMap.locationId"
                      :items="locations"
                      attach
                      :label="$t('lblLocation')"
                      item-value="id"
                      item-text="name"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      show-size
                      accept=".pdf"
                      :hint="$t('lblFileName')"
                      persistent-hint
                      prepend-icon
                      v-model="files"
                      append-icon="mdi-folder-search"
                      v-on:change="handleFileUpload"
                    />
                  </v-col>
                  <v-col cols="12" center>
                    <v-progress-linear v-if="progress > 0" v-model="progress" height="25" reactive>
                      <strong>{{ progress }}%</strong>
                    </v-progress-linear>
                  </v-col>
                  <v-col cols="12">
                    <p class="caption error--text" v-html="errorMessage"></p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeNewMapDialog()">{{$t("btnCancel")}}</v-btn>
            <v-btn text @click.stop="doNewMapDialog()" color="primary">{{$t("btnNewMap")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="editMapDialogFlag" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgEditMapTitle")}}</v-card-title>

          <v-card-text>
            <v-container>
              <v-form ref="editMapForm" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="currentMap.name" :label="$t('lblMapName')"></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field v-model="currentMap.comments" :label="$t('lblMapDescription')"></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-select
                      v-model="currentMap.locationId"
                      :items="locations"
                      attach
                      :label="$t('lblLocation')"
                      item-value="id"
                      item-text="name"
                    ></v-select>
                  </v-col>
                  
                  <v-col cols="12">
                    <p class="caption error--text" v-html="errorMessage"></p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeEditMapDialog()">{{$t("btnCancel")}}</v-btn>
            <v-btn text @click.stop="doEditMapDialog()" color="primary">{{$t("btnUpdateMap")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-text-field
        solo
        class="mt-4"
        :label="$t('headerSearch')"
        prepend-inner-icon="mdi-account"
        v-model="search"
      ></v-text-field>
      <v-data-table
        :loading="isLoading"
        :headers="headers"
        :items="maps"
        :search="search"
        sort-by="name"
        class="elevation-1"
        color="primary"
      >
        <template v-slot:top>
          <v-toolbar flat color="primary">
            <v-toolbar-title class="white--text">{{$t('tblTitle')}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn
              outlined
              color="white"
              @click.stop="showNewMapDialog()"
              tile
            >{{$t('dlgNewMapTitle')}}</v-btn>
          </v-toolbar>
        </template>
        <!-- PANEL CLIENTE -->
        <template v-slot:item.locationId="{ item }">
          <v-col>
            {{ getLocationName(item.locationId) }}
          </v-col>
        </template>
        <!-- PANEL ACTIVAR/DESACTIVAR -->
        <template v-slot:item.status="{ item }">
          <v-col v-if="item.status === 1">
            <v-btn icon color="primary" @click.stop="shiftMapStatus(item)">
              <v-icon>mdi-thumb-up</v-icon>
            </v-btn>
          </v-col>
          <v-col v-else>
            <v-btn icon color="grey" @click.stop="shiftMapStatus(item)">
              <v-icon>mdi-thumb-down</v-icon>
            </v-btn>
          </v-col>
        </template>

        <!-- PANEL DE ACCIONES -->
        <template v-slot:item.action="{ item }">
          <v-btn @click.stop="showMapDialog(item)" icon tile>
            <v-icon fab>mdi mdi-image</v-icon>
          </v-btn>
          <v-btn @click.stop="showEditMapDialog(item)" icon class="ml-2" tile>
            <v-icon fab>mdi mdi-pencil</v-icon>
          </v-btn>
          <v-btn @click.stop="showUploadMapDialog(item)" icon class="ml-2" tile>
            <v-icon>mdi mdi-upload</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <v-snackbar v-model="snackbar">
        {{ mensaje }}
        <v-btn color="primary" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </template>
  </layout>
</template>

<script>
// Incluimos el LAYOUT estandar para los usuario que ya tienen
// una sesión activa
import Layout from "@/components/Layouts/company";
// Incluimos los mensajes de esta pantalla
import i18nMessages from "./i18n.messages";
// Utilities
import { mapGetters } from "vuex";
import _ from "lodash";
import uuid from "uuid4";
import Pdf from "vue-pdf";

let DEFAULT_MAP_MODEL = { id: 0, resource: {} };
let DEFAULT_FILE_MODEL = { isValid: false, contentData: null };

let BASE_URL_FOR_MAPS = "content/meeting-rooms/maps/";

export default {
  // Se definen los componentes requeridos por esta pantalla
  components: {
    Layout,
    Pdf
  },
  created() {
    this.$i18n.locale = this.locale;
    this.updateHeadersLocale();
    // Obtenemos la lista de mapas
    this.loadLocations();
  },
  beforeDestroy() {},
  i18n: i18nMessages,
  data: function() {
    return {
      //variables  para control de validaciones
      snackbar: false,
      mensaje: "",
      // URL del mapa en el bucket, se utiliza para renderizar
      // el PDF cuando se solicita la visualización del mapa
      mapURL: "",
      pdfProgress: 0,
      // Se utiliza para conocer el porcentage
      // del proceso de UPLOAD de un archivo
      progress: 0,
      // Se utilizan como banderas (FLAG) para
      // los cuadros de dialogo
      editMapDialogFlag: false,
      newMapDialogFlag: false,
      deleteMapDialogFlag: false,
      uploadMapDialogFlag: false,
      viewMapDialogFlag: false,
      // Se utilizan para controlar el componente
      // INPUT FILE, que sirve para seleccionar y cargar
      // archivos
      files: [],
      // Archivo seleccionado
      currentFile: DEFAULT_FILE_MODEL,
      // Mensaje de error, si existe un mensaje de error
      // se almacena en está variable.
      errorMessage: "",
      search: "",
      //
      currentMap: DEFAULT_MAP_MODEL,
      //Encabezados de la tabla
      //La propiedad "id" corresponde al identificador de la etiqueta
      //en el archivo de mensajes que se utilizar para los idiomas
      headers: [
        {
          id: "headerName",
          text: "Name",
          sortable: true,
          value: "name"
        },
        {
          id: "headerDescription",
          text: "Descripción",
          value: "comments",
          sortable: false
        },
        {
          id: "headerLocation",
          text: "Localidad",
          sortable: true,
          value: "locationId"
        },
        {
          id: "headerStatus",
          text: "Estado",
          value: "status",
          sortable: false
        },
        {
          id: "headerAction",
          text: "Acciones",
          value: "action",
          sortable: false
        }
      ],
      //Contiene el set de datos de los mapas, los cuales se obtiene
      //de la lambda a través del método loadData()
      maps: [],
      locations: []
    };
  },
  mounted: () => {},
  computed: {
    ...mapGetters(["isLoading"]),
    locale() {
      return this.$store.getters["locale"];
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Ubicación" : "Editar Ubicación";
    }
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
      this.updateHeadersLocale();
    },
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    // Actualiza el idioma de los encabezados de la tabla
    updateHeadersLocale() {
      this.headers = this.headers.map(header => {
        header.text = this.$t(header.id);
        return header;
      });
    },
    /**
     * Obtiene el nombre de una ubicacion
     * @param locationId Id de la ubicacion
     */
    getLocationName(locationId){
      let location = this.locations.find( location => location.id == locationId);
      return location ? location.name : '';
    },
    loadLocations() {
      this.$GET("/api/locations")
        .then(locations => {
          this.locations = locations.map(location => {
          return {
            id: location.id,
            name: location.name
          };
        });
          this.loadData();
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          //** console.log(e);
        });
    },
    loadData() {
      this.$GET("/api/maps")
        .then(maps => {
          this.maps = maps;
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          //** console.log(e);
        });
    },
    setCurrentMap(map) {
      //Realizamos una copia del objeto map
      //utilizan el método clone de la utileria LODASH
      this.currentMap = _.clone(map);
    },

    setPdfProgress(progress) {
      this.pdfProgress = Math.ceil(progress * 100);
      //** console.log("PDF Progress:" + this.pdfProgress);
    },
    // MOSTRAR Mapa
    showMapDialog(map) {
      this.$Storage
        .get(`content/${map.resource.content}`)
        .then(url => {
          this.mapURL = url;
          this.viewMapDialogFlag = true;
          this.pdfProgress = 1;
        })
        .catch(() => {
          //** console.log(e)
        })
        .finally(() => {});
    },
    closeShowMapDialog() {
      this.currentMap = DEFAULT_MAP_MODEL;
      this.mapURL = "";

      this.viewMapDialogFlag = false;
    },

    // NUEVO mapa
    showNewMapDialog() {
      this.currentMap = DEFAULT_MAP_MODEL;
      this.currentFile = null;
      this.newMapDialogFlag = true;
    },
    closeNewMapDialog() {
      this.newMapDialogFlag = false;
      this.currentMap = DEFAULT_MAP_MODEL;
      this.currentFile = null;
      this.progress = 0;

      this.$refs.newMapForm.reset();
    },
    doNewMapDialog() {
      if (this.currentMap.name == null) {
        this.mensaje =
          "Corrige errores de validación, debes llenar el campo nombre";
        this.snackbar = true;
      } else if (this.currentFile == null) {
        //contentData: null
        this.mensaje =
          "Corrige errores de validación, debes seleccinar un archivo";
        this.snackbar = true;
      } else if (this.currentMap.locationId == null) {
        //contentData: null
        this.mensaje =
          "Corrige errores de validación, debes seleccinar una ubicación";
        this.snackbar = true;
      } else {
        this.doUploadMap(path => {
          path = path.replace("content/", "");
          let payload = {
            data: {
              status: 1,
              locationId: this.currentMap.locationId,
              index: 1,
              name: this.currentMap.name,
              comments: this.currentMap.comments,
              contentType: 1,
              resource: {
                resourceTypeId: 1,
                content: path
              }
            }
          };

          this.$POST("/api/maps", payload)
            .then(() => {
              this.closeNewMapDialog();
              this.loadLocations();
            })
            .catch(e => {
              // En caso de error presentar un mensaje
              // al usuario
              //** console.log(e);
              this.errorMessage = "Ocurrió un error al crear el mapa 1";
              throw e;
            })
            .finally(() => {});
        }).catch(() => {
          //** console.log(e);
          this.errorMessage = "Ocurrió un error al actualizar el mapa";
          // throw e;
        });
      }
    },

    // EDIT Map
    showEditMapDialog(map) {
      this.setCurrentMap(map);
      this.editMapDialogFlag = true;
    },
    closeEditMapDialog() {
      this.currentMap = DEFAULT_MAP_MODEL;
      this.editMapDialogFlag = false;
      this.$refs.editMapForm.reset();
    },
    doEditMapDialog() {
      //Eliminamos la propiedad "resource" del objeto mapa
      //Para la actualizacion solamente se envían los datos del mapa
      delete this.currentMap.resource;

      //PAYLOAD para el PUT
      let payload = {
        params: {
          mapId: this.currentMap.id
        },
        data: this.currentMap
      };

      this.$PUT("/api/maps/{{mapId}}", payload)
        .then(() => {
          //** console.log(response);
          this.loadLocations();
          this.closeEditMapDialog();
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          //** console.log(e);
          this.errorMessage = "Ocurrió un error al actualizar el mapa";
        })
        .finally(() => {});
    },

    // UPLOAD Map
    showUploadMapDialog(map) {
      this.setCurrentMap(map);
      this.uploadMapDialogFlag = true;
    },
    closeUploadMapDialog() {
      this.uploadMapDialogFlag = false;
      this.currentFile = null;
      this.progress = 0;
      this.$refs.updateMapForm.reset();
    },
    doUploadMapDialog() {
      this.errorMessage = "";

      if (this.currentFile.isValid) {
        this.doUploadMap(path => {
          path = path.replace("content/", "");
          let payload = {
            params: {
              mapId: this.currentMap.id,
              resourceId: this.currentMap.resource.id
            },
            data: {
              resourceTypeId: 1,
              content: path,
              lastUpdate: this.currentMap.resource.lastUpdate
            }
          };

          return this.$PUT(
            "/api/maps/{{mapId}}/resource/{{resourceId}}",
            payload
          )
            .then(() => {
              //** console.log(response);
              this.closeUploadMapDialog();
              this.loadLocations();
            })
            .catch(() => {
              // En caso de error presentar un mensaje
              // al usuario
              //** console.log(e);
              this.errorMessage = "Ocurrió un error al actualizar el mapa";
            })
            .finally(() => {});
        });
      } else {
        this.errorMessage = "El archivo no es válido";
      }
    },

    //HABILITAR/DESHABILITAR
    shiftMapStatus(map) {
      //PAYLOAD para el PUT
      this.setCurrentMap(map);
      //** console.log(this.currentMap)
      this.currentMap.status = this.currentMap.status === 1 ? 0 : 1;
      let payload = {
        params: {
          mapId: this.currentMap.id
        },
        data: this.currentMap
      };

      this.$PUT("/api/maps/{{mapId}}", payload)
        .then(() => {
          //** console.log(response);
          this.loadData();
          this.currentMap = DEFAULT_MAP_MODEL;
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          //** console.log(e);
          this.errorMessage = "Ocurrió un error al HABILITAR el mapa";
        })
        .finally(() => {});
    },

    // DELETE Map
    showDeleteMapDialog(map) {
      this.setCurrentMap(map);
      this.deleteMapDialogFlag = true;
    },
    closeDeleteMapDialog() {
      this.currentMap = DEFAULT_MAP_MODEL;
      this.deleteMapDialogFlag = false;
    },
    doDeleteMapDialog() {
      //PAYLOAD parra el DELETE
      let payload = {
        params: {
          mapId: this.currentMap.id
        },
        data: {
          lastUpdate: this.currentMap.lastUpdate
        }
      };
      // Limpiamos el mensaje de error, en caso de tener un
      // error previo
      this.errorMessage = "";
      this.$DELETE("/api/maps/{{mapId}}", payload)
        .then(() => {
          this.closeDeleteMapDialog();
          this.loadData();
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          //** console.log(e);
          this.errorMessage = "Ocurrió un error al eliminar el mapa";
        })
        .finally(() => {});
    },

    // Manejador del archivo
    handleFileUpload(currentFile) {
      let self = this;

      if (!currentFile || currentFile.length === 0) {
        this.currentFile = null;
      } else if (currentFile.type != "application/pdf") {
        self.errorMessage = self.$t("lblFileTypeError");
      } else {
        self.$store.dispatch("initLoader");
        self.currentFile = currentFile;
        self.currentFile.isValid = false;
        self.currentFile.contentData = null;
        self.errorMessage = "";

        let reader = new FileReader();
        reader.onload = function(e) {
          try {
            let data = new Uint8Array(e.target.result);
            self.currentFile.contentData = data;
            self.currentFile.isValid = true;
          } catch (error) {
            window.self.errorMessage = error.message; //** console.log(error);
          } finally {
            self.$store.dispatch("stopLoader");
          }
        };
        reader.readAsArrayBuffer(self.currentFile);
      }
    },
    // Carga el archivo en el bucket S3
    async doUploadMap(callback) {
      this.totalSteps = 0;
      this.completedSteps = 0;

      if (this.currentFile.isValid && this.currentFile.contentData) {
        let path = `${BASE_URL_FOR_MAPS}${uuid()}.pdf`;
        //** console.log("Content id:" + path);
        return this.$Storage.put(
          path,
          this.currentFile.contentData,
          this.uploadProgressCallback,
          () => {
            //** console.log("UPLOADED");
            //** console.log(response);
            return callback(path);
          }
        );
      } else {
        throw new Error("Invalid file");
      }
    },
    // Progess callback
    uploadProgressCallback(progress) {
      this.progress = Math.ceil((progress.loaded / progress.total) * 100);
      /** console.log(
        `Uploaded: ${progress.loaded}/${progress.total}  ${this.progress}%`
      );*/
    }
  }
};
</script>